import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import { BrowserRouter } from 'react-router-dom';

import App from './components/App/App';

import { i18n } from 'element-react'
import locale from 'element-react/src/locale/lang/es'

i18n.use(locale);

render(
  <Provider store={store}>
    <BrowserRouter basename="/dashboard">
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js